let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ggbeo")).then(() => parcelRequire('6XJCa'));